import "./App.css";
import { useAuthContext } from "./context/AuthContext";
import Layout from "./components/container/Layout";
// import DashboardHome from "./components/home/DashboardHome";
// import Settings from "./components/settings/Settings";
import ProfilePage from "./components/profile/ProfilePage";
import EditProfilePage from "./components/profile/EditProfilePage";
import AboutUsPage from "./components/aboutus/AboutUsPage";
import Loader from "./components/basic/Loader";
import GettingStarted from "./components/getting-started/GettingStarted";
import ResultPage from "./components/getting-started/ResultPage";
import GamePage from "./components/games/game_page";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import PageNotFound from "./components/PageNotFound";
// import LoginPage from "./components/auth/LoginPage";
import { useEffect, useRef } from "react";
import { onFirebaseMessageListener } from "./firebase/Firebase";
import { toast } from "react-toastify";
import logo from "./assets/logo_only.png";
import PracticePage from "./components/practice-page/PracticePage";
import PerformancePage from "./components/performance-page/PerformancePage";
import { AppProvider } from "./context/AppContext";
import OpenReplay from "@openreplay/tracker";
import trackerAssist from "@openreplay/tracker-assist";
import ProgramDetailsPage from "./components/programs/ProgramDetailsPage";
import RegisterPage from "./components/auth/Register";
import LandingPage from "./components/discovery/LandingPage";
import TestimonialsPage from "./components/discovery/TestimonialsPage";
import FaqPage from "./components/discovery/FaqPage";
import PolicyPage from "./components/privacy-terms/PolicyPage";
import PricingPage from "./components/subscription/PricingPage";
import ScienceBehindPage from "./components/discovery/ScienceBehindPage";
import BillingPage from "./components/billing/BillingPage";
import BillingAfter from "./components/billing/BillingAfter";
import OnboardingPage from "./components/auth/OnboardingSteps";
import NewPrograms from "./components/programs/NewPrograms";
import PopupMsg from "./components/programs/PopupMsg";
import JoinProgram from "./components/programs/JoinProgram";
import Model from "./components/programs/Model";
import RoutinePage from "./components/home/RoutinePage";
import NewPerformance from "./components/performance-page/NewPerformance";
import NewActivity from "./components/performance-page/NewActivity";
import NewProfilePage from "./components/profile/NewProfilePage";
import FitnessAge from "./components/discovery/FitnessAge";
import FitnessResult from "./components/discovery/FitnessResult";
import CardioHealth from "./components/discovery/CardioHealth";
import { CardioResult } from "./components/discovery/CardioResult";
import Wellness from "./components/wellness/Wellness";
import NewHeader from "./components/container/NewHeader";
import NewLoginPage from "./components/auth/NewLoginPage";
import FreeTrialLanding from "./components/discovery/FreeTrialLanding";
import GamesField from "./components/home/GamesField";
import RegistrationComplete from "./components/auth/RegistrationComplete";
import PaymentComplete from "./components/subscription/PaymentComplete";
import RewardPopup from "./components/reward/RewardPopup";
import WellnessFreeTrial from "./components/wellness/WellnessFreeTrial";
import FitAThonRegistration from "./components/auth/Fit-A-ThonRegister";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  Redirect,
} from "react-router-dom";

function RequireAuth({ children }) {
  let auth = useAuthContext();
  let location = useLocation();

  if (auth.state.isLoading) {
    return <Loader />;
  }

  if (!auth.state.user) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    const query = new URLSearchParams(location.search);
    if (Object.keys(Object.fromEntries(query)).length > 0) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

// after login redirect to the program page, on register route
function RedirectProgram() {
  const auth = useAuthContext();
  return auth.state.user ? (
    <Navigate to="/programpage" state={{ from: "/register" }} replace />
  ) : (
    <RegisterPage />
  );
}

function App() {
  const auth = useAuthContext();
  const trackerRef = useRef();
  //...

  useEffect(() => {
    document.addEventListener("contextmenu", (e) => {});
  }, []);
  async function startTracker() {
    if (!auth.state.isLoading && !trackerRef.current) {
      try {
        trackerRef.current = new OpenReplay({
          projectKey: "FCAhXNPHAwvilfxiRYoM",
          __DISABLE_SECURE_MODE: true,
          ingestPoint: "https://openreplay.eastus.cloudapp.azure.com/ingest",
          respectDoNotTrack: false,
        });
        trackerRef.current.use(
          trackerAssist({
            onAgentConnect: () => {
              console.log("Live session started");
              const onAgentDisconnect = () =>
                console.log("Live session stopped");
              return onAgentDisconnect;
            },
            onCallStart: () => {
              console.log("Call started");
              const onCallEnd = () => console.log("Call ended");
              return onCallEnd;
            },
            onRemoteControlStart: () => {
              console.log("Remote control started");
              const onCallEnd = () => console.log("Remote control ended");
              return onCallEnd;
            },
          })
        ); // check the list of available options below

        if (auth.state.user) {
          trackerRef.current.setUserID(auth.state.user.email);
          trackerRef.current.setMetadata("name", auth.state.user.fullname);
          trackerRef.current.setMetadata("email", auth.state.user.email);
        }

        if (!trackerRef.current.isActive) {
          const promis = await trackerRef.current.start({
            userID: auth.state.user?.email || "Not Logged In",
            metadata: {
              email: auth.state.user?.email || "Not Logged In",
              name: auth.state.user?.fullname || "Not Logged In",
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
  useEffect(() => {
    startTracker();
    return () => {
      if (trackerRef.current) {
        trackerRef.current = null;
      }
    };
  }, [auth.state]);

  onFirebaseMessageListener()
    .then((payload) => {
      toast(
        <div className="flex flex-row space-x-3 ">
          <img src={logo} className="rounded-full w-10 h-10" />
          <div className="flex flex-col space-y-2">
            <p className="font-bold text-lg  flex-1">
              {payload.notification.title}
            </p>
            <p className=" font-medium ">{payload.notification.body}</p>
          </div>
        </div>,
        { type: "notification" }
      );
    })
    .catch((err) => console.log("failed: ", err));
  return (
    <GoogleOAuthProvider clientId={`${process.env.REACT_APP_PUBLIC_GOOGLE_ID}`}>
      <AppProvider>
        <Layout>
          <Routes>
            {/* All routes go here */}
            <Route index element={<LandingPage />} />
            <Route path="billingbefore" element={<BillingPage />} />
            <Route
              path="programpage"
              element={
                <RequireAuth>
                  <NewPrograms />
                </RequireAuth>
              }
            />
            <Route
              path="settings"
              element={
                <RequireAuth>
                  <BillingAfter />
                </RequireAuth>
              }
            />
            <Route
              path="profile"
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />
            <Route
              path="edit-profile"
              element={
                <RequireAuth>
                  <EditProfilePage />
                </RequireAuth>
              }
            />
            <Route
              path="program/:programId"
              element={
                <RequireAuth>
                  <ProgramDetailsPage />
                </RequireAuth>
              }
            />
            {/* <Route
              path="programpage"
              element={
                <NewPrograms />
              }
            /> */}
            <Route path="get-started" element={<GettingStarted />} />
            <Route
              path="privacy"
              element={<PolicyPage defaultTab="privacy" />}
            />
            <Route path="terms" element={<PolicyPage defaultTab="terms" />} />
            <Route
              path="refund-policy"
              element={<PolicyPage defaultTab="refund" />}
            />
            <Route
              path="disclaimer"
              element={<PolicyPage defaultTab="disclaimer" />}
            />
            <Route path="about-us" element={<AboutUsPage />} />
            <Route path="testimonials" element={<TestimonialsPage />} />
            <Route path="faq" element={<FaqPage />} />
            <Route path="subscription" element={<PricingPage />} />
            <Route
              path="science-behind-every-move"
              element={<ScienceBehindPage />}
            />
            <Route path="/result/:resultId" element={<ResultPage />} />
            <Route
              path="/game/:gameId"
              element={
                // <RequireAuth>
                <GamePage />
                // </RequireAuth>
              }
            />
            {/* <Route path="/login" element={<LoginPage />} /> */}
            <Route
              path="/register"
              element={
                <RedirectProgram>
                  <RegisterPage />
                </RedirectProgram>
              }
            />
            <Route
              path="/practice"
              element={
                <RequireAuth>
                  <PracticePage />
                </RequireAuth>
              }
            />
            <Route
              path="/routines"
              element={
                <RequireAuth>
                  <RoutinePage />
                </RequireAuth>
              }
            />
            <Route
              path="/performance"
              element={
                <RequireAuth>
                  <NewPerformance />
                </RequireAuth>
              }
            />
            {/* <Route path="/*" element={<PageNotFound />} /> */}
            <Route path="/*" element={<Navigate to="/programpage" />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/onboard" element={<OnboardingPage />} />
            <Route path="/popupmsg" element={<PopupMsg />} />
            <Route path="/joinprogram" element={<JoinProgram />} />
            <Route path="/modelpage" element={<Model />} />
            <Route path="/oldperformance" element={<PerformancePage />} />
            <Route path="/newactivity" element={<NewActivity />} />
            <Route path="/newprofilepage" element={<NewProfilePage />} />
            <Route path="/fitnessage" element={<FitnessAge />} />
            <Route path="/fitnessresult" element={<FitnessResult />} />
            <Route path="/cardiohealth" element={<CardioHealth />} />
            <Route path="/cardioresult" element={<CardioResult />} />
            <Route path="/Wellness" element={<Wellness />} />
            <Route path="/Newheader" element={<NewHeader />} />
            <Route path="/program" element={<Navigate to="/programpage" />} />
            <Route path="/newLogin" element={<NewLoginPage />} />
            <Route path="/free-trial" element={<FreeTrialLanding />} />
            <Route path="/games" element={<GamesField />} />
            <Route
              path="/registration_Complete"
              element={<RegistrationComplete />}
            />
            <Route path="/payment_Complete" element={<PaymentComplete />} />
            <Route path="/WellnessFreeTrial" element={<WellnessFreeTrial />} />
            <Route path="/reward" element={<RewardPopup />} />
            <Route path="/fit-a-thon" element={<FitAThonRegistration />} />
          </Routes>
        </Layout>
      </AppProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
